import api from '@/api';
import { User } from '@/types/api/user';
import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

type TData = void;
type TVariables = Partial<User>;

export function useUpdateCurrentUserMutation(options?: UseMutationOptions<TData, Error, TVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-current-user'],
    mutationFn: (data: TVariables) => api.user.updateCurrent(data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['users'] }),
    ...options,
  });
}
